module.exports = __webpack_public_path__ + "img/violet_141.d88909ed.png";